export default class Check {
	constructor() {
		this.radioButtons = document.querySelectorAll('.js-CheckRadio');
		this.resultButton = document.querySelector('.js-ResultButton');
		this.returnButton = document.querySelector('.js-Return');
		this.checkSection = document.getElementById('check');
		this.resultSection = document.getElementById('result');
		this.selfCheckContainer = document.getElementById('selfcheck');
		this.resultHeadline = this.resultSection?.querySelector('.js-ResultBox__Headline');
		this.resultLead = this.resultSection?.querySelector('.js-ResultBox__Lead');
		this.resultText = this.resultSection?.querySelector('.js-RsultMessage__Text');
		this.errorText = document.querySelector('.js-ErrorText');
		this.lineModal = document.querySelector('.js-check-line-modal');
		this.lineModalTriggers = document.querySelectorAll('.js-check-line-modal-trigger');
		this.lineModalClose = document.querySelector('.js-check-line-modal-close');
		this.lastLineModalTrigger = null;

		if (this.lineModal && this.lineModalTriggers.length > 0 && this.lineModalClose) {
			this.initLineModal();
		}

		// 要素が存在するページだけ処理
		if (this.radioButtons.length > 0 && this.resultButton && this.returnButton) {
			this.addEventListeners();
		}
	}

	initLineModal() {
		this.lineModalTriggers.forEach(trigger => {
			trigger.addEventListener('click', event => {
				if (window.innerWidth < 768 || typeof this.lineModal.showModal !== 'function') return;

				event.preventDefault();
				this.lastLineModalTrigger = trigger;
				this.lineModal.showModal();
				document.documentElement.classList.add('is-check-line-modal-open');
			});
		});

		this.lineModalClose.addEventListener('click', () => this.lineModal.close());
		this.lineModal.addEventListener('click', event => {
			if (event.target === this.lineModal) this.lineModal.close();
		});
		this.lineModal.addEventListener('close', () => {
			document.documentElement.classList.remove('is-check-line-modal-open');
			this.lastLineModalTrigger?.focus();
			this.lastLineModalTrigger = null;
		});
	}

	addEventListeners() {
		this.resultButton.addEventListener('click', () => this.showResult());
		this.returnButton.addEventListener('click', () => this.resetForm());
	}

	showResult() {
		let total = 0;
		this.radioButtons.forEach(radio => {
			if (radio.checked) {
				total += parseInt(radio.value, 10);
			}
		});
		this.renderResult(total);
		this.openResultSection();
	}

	openResultSection() {
		if (this.checkSection) {
			this.checkSection.style.opacity = '0';
			this.checkSection.style.display = 'none';
		}
		if (this.resultSection) {
			this.resultSection.style.opacity = '1';
			this.resultSection.style.display = 'block';
		}
		this.selfCheckContainer?.scrollIntoView({ behavior: 'smooth' });
	}

	resetForm() {
		this.radioButtons.forEach(radio => {
			radio.checked = false;
		});
		if (this.resultSection) {
			this.resultSection.style.opacity = '0';
			this.resultSection.style.display = 'none';
		}
		if (this.checkSection) {
			this.checkSection.style.opacity = '1';
			this.checkSection.style.display = 'block';
		}
		this.selfCheckContainer?.scrollIntoView({ behavior: 'smooth' });
	}

	renderResult(score) {
		if (!this.resultHeadline || !this.resultLead || !this.resultText) return;

		if (score >= 88) {
			this.resultHeadline.textContent = '頭皮は危険な状態です。進行性の脱毛症状になっている可能性があります。';
			this.resultLead.textContent = '脱毛症と思われる症状が見られるようです。または、その傾向が非常に高くなっています。この機会に薄毛治療専門クリニックの医師の診断と適切な治療を受けられることをおすすめします。';
			this.resultText.textContent = '市販の育毛剤や発毛剤などを使ってみるのも改善策の１つですが、女性の薄毛や抜け毛はストレス、ホルモンバランスの乱れ、過度なダイエット、誤ったヘアケア、老化など、原因はひとり一人違います。現状を考えると、専門の医療機関での治療・処方を受けることが、より安全でかつ効果が期待できると考えられます。';
		} else if (score >= 51) {
			this.resultHeadline.textContent = '少し注意が必要です。髪と頭皮の環境を今すぐ改善しましょう。';
			this.resultLead.textContent = '脱毛症と思われる傾向がやや見受けられるようです。以前と比べ、スタイリングがうまくいかない、髪にボリュームが出ない、抜け毛の量が気になってきた、と思ったらそろそろ具体的な改善策が必要です。';
			this.resultText.textContent = 'まずは、食事・生活習慣を見直してみましょう。そして、毎日の正しいヘアケアも重要です。市販の育毛剤や発毛剤などを使ってみるのも改善策の１つですが、女性の薄毛はホルモンバランスの変化やダイエットなど、原因は様々です。髪が気になり始めたら、専門の医療機関に相談して現在の髪の状態を把握し、改善に取り組みましょう。';
		} else if (score >= 23) {
			this.resultHeadline.textContent = '現在問題はありませんが、油断は禁物です。';
			this.resultLead.textContent = '現在は特に心配はないと思われますが、「薄毛」「抜け毛」は食事や生活習慣、日常のヘアケアなどと密接に関係していることが多くあります。できるだけ、健康的な生活を心がけてください。';
			this.resultText.textContent = '「薄毛」「抜け毛」は、日常生活の乱れや、それに伴う不摂生により発症することもあります。年齢（加齢）に伴う薄毛はしかたないですが、それ以外の要因は、さまざまな方法で回避できます。少しでも髪に不安を感じたら、できるだけ早めに対処して、髪と身体を健康に保ちましょう。';
		} else {
			this.resultHeadline.textContent = '心配いりません。あなたは健康な髪と頭皮の持ち主です！';
			this.resultLead.textContent = '「薄毛」「抜け毛」の原因の多くは、食事や生活習慣、日常のヘアケアなどと密接に関係しています。結果に満足することなく、これからも健康な髪と頭皮をキープしてください。';
			this.resultText.textContent = '「薄毛」「抜け毛」は、日常生活の乱れや、それに伴う不摂生がきっかけとなって発症することもあります。年齢（加齢）に伴う薄毛はしかたないですが、それ以外の要因は、さまざまな方法で回避できます。早くからの対処が髪にも身体にも有効と言えます。';
		}
	}

	showError() {
		if (this.errorText) {
			this.errorText.style.display = 'block';
		}
	}
}
